export default {
  name: 'app'
}